/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_customer_metafields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyIntegrationIdFetchCustomerMetafields } from "./constants";
import type { GetAlloysPartnersShopifyIntegrationIdFetchCustomerMetafieldsResult } from "./types";
import { isGetAlloysPartnersShopifyIntegrationIdFetchCustomerMetafieldsResult } from "./validators";

export const getAlloysPartnersShopifyIntegrationIdFetchCustomerMetafields = reactQueryFetcherAdapter(
  alloysPartnersShopifyIntegrationIdFetchCustomerMetafields,
  (
    signal: AbortSignal,
    integrationId: string
  ): Promise<GetAlloysPartnersShopifyIntegrationIdFetchCustomerMetafieldsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_customer_metafields`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyIntegrationIdFetchCustomerMetafieldsResult
);
